import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportHourlySalesReport } from 'utils/breadcrumbInfo';
import { getHourlySalesSecondary, getCsvReport } from 'actions/ReportsAction';
import { formInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
// Child Component
import Header from './Header';
import Body from './Body';

const HourlySalesSecondary = () => {
    const agGridRef = useRef(null);
    // Redux State
    const dispatch = useDispatch();
    const { userBranches = [], branchId: loggedBranch } = useSelector(state => state.common || {});
    const { HourlySalesSecondaryBranchOption: selectedBranch, HourlySalesSecondaryStartDate, HourlySalesSecondaryEndDate } = useSelector(state => state.form || {});
    const branchOptions = [];
    userBranches.map((item) => {
        branchOptions.push({ text: item.name, value: item.id.toString() });
    })
    const startDate = moment(HourlySalesSecondaryStartDate).format("YYYY-MM-DD");
    const endDate = moment(HourlySalesSecondaryEndDate).format("YYYY-MM-DD");

    // Local State
    const [showBody, setShowBody] = useState(false);

    useEffect(() => {
        const date = new Date();
        dispatch(formInput(new Date(date.getFullYear(), date.getMonth(), 1), 'HourlySalesSecondaryStartDate'));
        dispatch(formInput(date, 'HourlySalesSecondaryEndDate'));
    }, []);

    const getReport = () => {
        const branch = selectedBranch ? selectedBranch : loggedBranch;
        dispatch(getHourlySalesSecondary({ branch, startDate, endDate }));
    };

    const downloadReport = () => {
        if (agGridRef.current && agGridRef.current.api){
            agGridRef.current.api.exportDataAsCsv({
                fileName: `HourlySalesAveraged.csv`,
                processCellCallback: (params) => {
                    // Export clean numeric values or Total label
                    if (params.value === "Total") return "Total";
                    if (typeof params.value === "number") return params.value.toFixed(2);
                    if (typeof params.value === "string") return params.value.replace(/[$,%]/g, '');
                    return params.value;
                },
                skipHeader: false,
                allColumns: true,
                customHeader: null,
                customFooter: null,
                includePinnedRows: true,
                shouldRowBeSkipped: (params) => {
                    return !params.node.displayed; // skip rows not currently visible (filtered out)
                }
            });
        }else{
            let branch = selectedBranch ? selectedBranch : loggedBranch;
            if (checkDateRange(startDate, endDate)) {
                dispatch(showError(LOOKUP.report.common.dateRangeError));
            } else {
                dispatch(getCsvReport(`reports/excel/hourlysalessecondary?branchid=${branch}&startDate=${startDate}&endDate=${endDate}`, 'HourlySalesAveraged'));
            }
        }
    };

    const showBodyContent = () => {
        if (checkDateRange(startDate, endDate)) {
            dispatch(showError(LOOKUP.report.common.dateRangeError));  // Dispatch error if date range is invalid
        } else {
            getReport();
            setShowBody(true);
        }
    };

    return (
        <Grid headerContent={reportHourlySalesReport}>
            <PageHeader title={LOOKUP.report.hourlySalesSecondary.text} description={LOOKUP.report.hourlySalesSecondary.description} />
            <Header
                branchOptions={branchOptions}
                download={downloadReport}
                showBody={showBodyContent}
                loggedBranch={loggedBranch}
            />
            {showBody && <Body agGridRef={agGridRef} startDate={startDate} endDate={endDate} />}
        </Grid>
    )
}

export default HourlySalesSecondary;